import api from './Api'

const route = '/auth'

export default {
  login: credentials => api().post(`${route}/login`, credentials),
  signup: userDetails => api().post(`${route}/signup`, userDetails),
  switchSession: email => api().post(`${route}/session/switch`, email)

}
